export const WGPT_BOARD_LIST_CARD_ACTIVITES_QUERY_LIMIT = 5;
